import request, { ResponseData } from '@/utils/request'
import {
  SaveToolReq,
  toolListReq,
  toolDetailReq,
  toolMoveReq,
  toolGroupSaveReq,
  toolGroup,
  toolBindReq,
  saveToolRecordReq,
} from './model'

// 保存工具
export async function saveTool(params): Promise<ResponseData<SaveToolReq>> {
  return request('/api/v1/training/tool/save', {
    method: 'post',
    data: params,
  })
}

// 获取工具列表
export async function fetchToolsList(params): Promise<ResponseData<toolListReq>> {
  return request('/api/v1/training/tool/list', {
    method: 'post',
    data: params,
  })
}

// 获取工具详情
export async function fetchToolsDetail(params): Promise<ResponseData<toolDetailReq>> {
  return request('/api/v1/training/tool/detail', {
    method: 'post',
    data: params,
  })
}

// 工具批量分组
export async function toolsMove(params): Promise<ResponseData<toolMoveReq>> {
  return request('/api/v1/training/tool/move', {
    method: 'post',
    data: params,
  })
}

// 工具批量删除
export async function toolsDelete(params) {
  return request('/api/v1/training/tool/del', {
    method: 'post',
    data: params,
  })
}

// 工具分组列表
export async function FetchToolsGroup(params): Promise<ResponseData<toolGroupSaveReq>> {
  return request('/api/v1/training/tool/group/list', {
    method: 'post',
    data: params,
  })
}

// 工具分组保存
export async function toolsGroupSave(params): Promise<ResponseData<toolGroup>> {
  return request('/api/v1/training/tool/group/save', {
    method: 'post',
    data: params,
  })
}

// 工具分组删除
export async function toolsGroupDelete(params) {
  return request('/api/v1/training/tool/group/del', {
    method: 'post',
    data: params,
  })
}

// 工具库一键清空
export async function emptyToolsGroups() {
  return request('/api/v1/training/tool/group/clear', {
    method: 'post',
  })
}

// 工具绑定
export async function toolsBind(params): Promise<ResponseData<toolBindReq>> {
  return request('/api/v1/training/tool/bind', {
    method: 'post',
    data: params,
  })
}

// 保存工具使用记录
export async function saveToolsRecord(params): Promise<ResponseData<saveToolRecordReq>> {
  return request('/api/v1/training/tool/record_save', {
    method: 'post',
    data: params,
  })
}

// 查询工具使用记录
export async function queryToolsRecord(params) {
  return request('/api/v1/training/tool/record_query', {
    method: 'post',
    data: params,
  })
}
